import { extendTheme } from '@chakra-ui/react';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  BG_SECONDARY_TRANSPARENT,
  BG_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_PRIMARY_LIGHT,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: 'Marcellus SC',
    subHeading: 'Marcellus SC',
    body: 'EB Garamond',
    body_lv2: 'Marcellus SC',
    fullName: 'Marcellus SC',
    jost: `'Jost', serif`,
  },
  fontSizes: {
    heading: '36px',
    subHeading: '26px',
    body: '18px',
    body_lv2: '18px',
    fullName: '26px',

  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    body_lv2: 400,
    fullName: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-fullName': '',
      },
    },
  },
  colors: {
    bgPrimary: '#FFF',
    bgSecondary: 'rgba(179,167,155,1)',
    bgAlternative: 'rgba(222,210,197,1)',
    mainColorText: '#352023',
    secondaryColorText: '#FFF',
    mainColorTextLight: 'rgba(53,32,35,1)',

    transparent: 'transparent',
    theme: {
      bgPrimaryText: TEXT_PRIMARY,
      bgPrimary: BG_PRIMARY,
      bgSecondary: BG_SECONDARY,
      bgSecondaryTransparent: BG_SECONDARY_TRANSPARENT,
    },
    button: {
      secondary: {
        500: BG_SECONDARY,
      },
      secondaryDark: {
        500: BG_ALTERNATIVE,
      },
    },
  },
  shadows: {
    outline: BG_ALTERNATIVE,
  },
};

export default extendTheme(theme);
